import React, { useState, useEffect } from "react";
import { Modal, Button, Typography } from "antd";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import moment from "moment";
import calendarIcon from "../../Assets/calender/info-calendar-outline.png";
import "./DateModalTask.css";
import { RightOutlined, LeftOutlined } from "@ant-design/icons";

const DateModalTask = ({ show, handleClose, onDateSelect, selectedDate }) => {
  const [date, setDate] = useState(new Date());
  const [viewDate, setViewDate] = useState(new Date());
  const [error, setError] = useState("");
  const { Title } = Typography;
  // console.log("Selected Date:", selectedDate);
  useEffect(() => {
    if (!selectedDate) {
      setDate(null);
      setViewDate(new Date());
      return;
    }

    // Accept both string and Date inputs
    const parsedFromFormat = moment(selectedDate, "D MMMM YYYY", true);
    const parsedGeneric = moment(selectedDate);
    const targetMoment = parsedFromFormat.isValid()
      ? parsedFromFormat
      : parsedGeneric.isValid()
        ? parsedGeneric
        : null;

    if (targetMoment) {
      const dateObj = targetMoment.toDate();
      setDate(dateObj);
      setViewDate(dateObj);
    } else {
      setDate(null); // clear invalid date
      setViewDate(new Date()); // default to today
    }
  }, [selectedDate]);

  const handleDateChange = (selectedDate) => {
    setDate(selectedDate);
    setViewDate(selectedDate);
    setError("");
  };

  const handleSubmit = () => {
    if (!date) {
      setError("Please select a date.");
      return;
    }
    onDateSelect(moment(date).format("D MMMM YYYY"));
    handleClose();
  };

  const goToPreviousMonth = () => {
    setViewDate((prevDate) => {
      const newDate = new Date(prevDate);
      newDate.setMonth(newDate.getMonth() - 1);
      return newDate;
    });
  };

  const goToNextMonth = () => {
    setViewDate((prevDate) => {
      const newDate = new Date(prevDate);
      newDate.setMonth(newDate.getMonth() + 1);
      return newDate;
    });
  };

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return (
    <Modal
      open={show}
      width={600}
      onCancel={handleClose}
      footer={[
        <Button className="applyBtn" type="primary" onClick={handleSubmit}>
          Save
        </Button>,
      ]}
      centered
    >
      <div className="filter-header">
        <div className="calendar-head">
          <Title className="calenderTitle" level={3}>
            <img
              src={calendarIcon}
              alt="calendarIcon"
              width={18}
              style={{ marginRight: 5 }}
            />
            Select a Date
          </Title>
        </div>
      </div>

      <div
        className="calenderhead2"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px",
        }}
      >
        <div
          className="calenderheadlft"
          style={{ fontSize: "16px", fontWeight: "bold" }}
        >
          {moment(viewDate).format("MMMM YYYY")}
        </div>
        <div className="calenderRgt">
          <Button
            className="calenderNext"
            shape="circle"
            icon={<LeftOutlined />}
            onClick={goToPreviousMonth}
          />
          <Button
            className="calenderPrev"
            shape="circle"
            icon={<RightOutlined />}
            onClick={goToNextMonth}
          />
        </div>
      </div>

      <Calendar
        onChange={handleDateChange}
        value={date}
        activeStartDate={viewDate}
        className="custom-calendar"
        tileDisabled={({ date }) => date < today}
        tileClassName={({ date: tileDate }) => {
          const isToday = moment(tileDate).isSame(today, "day");
          const isSelected = moment(tileDate).isSame(date, "day");

          if (isToday) {
            return "today-highlight";
          }
          if (isSelected) {
            return "selected-highlight";
          }
          return null;
        }}
        showNavigation={false}
        onActiveStartDateChange={({ activeStartDate }) => {
          setViewDate(activeStartDate);
        }}
      />

      {error && <p style={{ color: "red", marginTop: "10px" }}>{error}</p>}
    </Modal>
  );
};

export default DateModalTask;
